import ImageLoader from './image_loader'

export default ImageLoader
